function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 16,
  cy: 16,
  r: 16
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "dax-flag-us",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 16,
  y: 1,
  width: 16,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 16,
  y: 7,
  width: 16,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 16,
  y: 13,
  width: 16,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 0,
  y: 19,
  width: 32,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 0,
  y: 25,
  width: 32,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  fill: "#C20000",
  mask: "url(#mask-2)",
  x: 0,
  y: 31,
  width: 32,
  height: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#244185",
  mask: "url(#mask-2)",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 12.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-5",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 4.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-7",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 0.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-3",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 8.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-4",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.000000, 8.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 12.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-6",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 4.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))), /*#__PURE__*/React.createElement("g", {
  id: "yrygSxB-white-star-vector-Copy-2",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 12.000000)",
  id: "path4968"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "1.50082963 2.28408548 0.573932923 3 0.934264316 1.8520805 0 1.14649549 1.14980735 1.15194139 1.49946563 0 1.84984585 1.15133755 3 1.14487486 2.06674047 1.85094817 2.42799838 2.99891088"
}))));

function SvgDaxFlagUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "US") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxFlagUs);
export default __webpack_public_path__ + "static/media/dax-flag-us.54f787f4.svg";
export { ForwardRef as ReactComponent };